import {
    GET_ATTENDEE_ME,
    UPDATE_ATTENDEE_ME,
    TOGGLE_MY_ATTENDEE_ACTIVE_STATUS,
    ATTENDEE_ERROR,
    UPDATE_ATTENDEE_ERROR,
    LOGOUT,
    GET_ALL_ATTENDEES_EDIT,
    TOGGLE_ATTENDEE_ACTIVE_STATUS,
    TOGGLE_ATTENDEE_ADMIN_ACTIVE_STATUS,
} from '../actions/types';

const initialState = {
    me: null,
    attendees: [],
    loading: true,
    error: {},
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case GET_ATTENDEE_ME:
        case UPDATE_ATTENDEE_ME:
        case TOGGLE_MY_ATTENDEE_ACTIVE_STATUS:
            return {
                ...state,
                me: payload,
                loading: false,
            };
        case GET_ALL_ATTENDEES_EDIT:
            return {
                ...state,
                attendees: payload,
                loading: false,
            };
        case TOGGLE_ATTENDEE_ACTIVE_STATUS:
        case TOGGLE_ATTENDEE_ADMIN_ACTIVE_STATUS:
            return {
                ...state,
                attendees: (state.attendees || []).map((attendee) => {
                    if (attendee._id === payload._id) {
                        return {
                            ...attendee,
                            ...payload,
                        };
                    }
                    return attendee;
                }),
                loading: false,
            };
        case UPDATE_ATTENDEE_ERROR:
        case ATTENDEE_ERROR:
            return {
                ...state,
                error: payload,
                loading: false,
            };
        case LOGOUT:
            return {
                ...state,
                me: null,
                attendees: [],
            };
        default:
            return state;
    }
}
